/**
 * Cash Out Program — ₹300 per ₹3,000 of order subtotal (pre-discount).
 * Each ₹300 fee creates one global COP ID (COP-000001, COP-000002, …) for all users in order.
 * Example: User A ₹6,000 + ₹600 → COP-000001 & COP-000002; User B ₹3,000 + ₹300 → COP-000003;
 * User A again → COP-000004.
 */

export const CASH_OUT_MIN_ORDER_SUBTOTAL = 3000;
export const CASH_OUT_BLOCK_AMOUNT = 3000;
export const CASH_OUT_FEE_PER_BLOCK = 300;

/** @deprecated Use cashOutMatrixConfig — enrollment is ₹150 matrix leg + ₹150 Rewards. */
export const CASH_OUT_AFP_MATRIX_AMOUNT = 150;
/** Cash Out Box still receives L1–L3 earnings + Step 4 COP program leg (₹150). */
export const CASH_OUT_BOX_WALLET_AMOUNT = 150;

export function qualifiesForCashOutProgram(orderSubtotal) {
  return Number(orderSubtotal) >= CASH_OUT_MIN_ORDER_SUBTOTAL;
}

/** One program ID per full ₹3,000 block (e.g. ₹9,000 → 3). */
export function getCashOutBlockCount(orderSubtotal) {
  if (!qualifiesForCashOutProgram(orderSubtotal)) return 0;
  return Math.floor(Number(orderSubtotal) / CASH_OUT_BLOCK_AMOUNT);
}

export function getCashOutEnrollmentFee(orderSubtotal) {
  return getCashOutBlockCount(orderSubtotal) * CASH_OUT_FEE_PER_BLOCK;
}

export function formatCashOutProgramPublicId(enrollmentSeq) {
  return `COP-${String(Number(enrollmentSeq)).padStart(6, "0")}`;
}

export function cashOutRequiredWithDiscounts(appliedDiscounts) {
  if (!appliedDiscounts) return false;
  return Boolean(
    appliedDiscounts.useCashback || appliedDiscounts.useCommission
  );
}
